import {useState} from 'react'
import SalesRateForm from './SalesRateForm';
import SalesRateList from './SalesRateList';

const SalesRate = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <SalesRateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <SalesRateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}
export default SalesRate